import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm1-8.414V8h-2v4.414l2.793 2.793 1.414-1.414L13 11.586z" }));
export default createSvgIcon(iconPath, "Pending review");
//# sourceMappingURL=StatusPendingReviewIcon.js.map